import { runtimeConfig } from './runtime-config';

const configured = runtimeConfig().basePath || '/';
const basePath = configured.endsWith('/') ? configured : `${configured}/`;

export function appPath(path: string) {
  return `${basePath}${path.replace(/^\/+/, '')}`;
}

export const routerBasename = basePath === '/' ? undefined : basePath.slice(0, -1);
